import { render } from "./VotingReportSettingsModal.vue?vue&type=template&id=18c31f10&scoped=true"
import script from "./VotingReportSettingsModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./VotingReportSettingsModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./VotingReportSettingsModal.vue?vue&type=style&index=0&id=18c31f10&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c31f10"]])

export default __exports__